import React from "react";


export default function Switch({ checked, onChange, ...props }) {
    return (
        <div
            className={`status-switch ${checked ? "active" : "inactive"}`}
            onClick={onChange}
            role="switch"
            aria-checked={checked}
            {...props}
        >
            <div className="status-slider"></div>
        </div>
    );
}